import { type ReactElement } from 'react'
import { CircularProgress } from '@mui/material'
import { SpinnerCenter } from './styles'

const SpinnerBlock = (): ReactElement<any, any> => {
  return (
    <SpinnerCenter>
      <CircularProgress color='primary' />
    </SpinnerCenter>
  )
}

export default SpinnerBlock
